// import "./SignUp.css"
// const SignUpApp = () => {

//   return (
//     <div className="App">
//       <div className="progress-bar"></div>
//       <div>Forms</div>
//     </div>
//   );
// };
// export default SignUpApp;
// import "./SignUp.css";
import { Input, Button } from "@material-ui/core";
import { useState } from "react";
import SignUp from "./Sign";
import Personal from "./Personal";
import Social from "./Social";
import University from "./University";
import Other from "./Other";
import { OtherHousesSharp } from "@mui/icons-material";

function SignUpApp() {
  const [page, setPage] = useState(0);

  const [x, setX] = useState(0);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    instagram: "",
    telegramUsername: "",
    phoneNumber: "",
    birthday: "",
    joined: "",
    expectedGraduationDate: "",
    shortBio: "",
    university: "",
    department: "",
    leetcode: "",
    codeforces: "",
    favoriteLanguage: "",
    tshirtSize: "",
    tshirtColor: "",
    github: "",
    hackerrank: ""
  });

  const componentList = [
    <SignUp
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
      x={x}
      setX={setX}
    />,
    <Personal
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
      x={x}
      setX={setX}
    />,
    <Social
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
      x={x}
      setX={setX}
    />,
    <University
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
      x={x}
      setX={setX}
    />,
    <Other
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
      x={x}
      setX={setX}
    />
  ];
  console.log(formData);
  return (
    <div className="App">
      <div className="progress-bar">
        {
          <div
            style={{
              width:
                page === 0
                  ? "25%"
                  : page === 1
                  ? "50%"
                  : page === 2
                  ? "75%"
                  : "100%"
            }}
          ></div>
        }
      </div>

      <div className="body">{componentList[page]}</div>
    </div>
  );
}

export default SignUpApp;
